var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.776 0H6.22783C2.79483 0 0.00195312 2.66054 0.00195312 5.93089V15.9795C0.00195312 19.2496 2.79483 21.9102 6.22783 21.9102H16.7762C20.209 21.9102 23.0019 19.2496 23.0019 15.9795V5.93089C23.0019 2.66054 20.209 0 16.776 0V0ZM11.5019 16.946C8.03418 16.946 5.21306 14.2585 5.21306 10.9551C5.21306 7.65165 8.03418 4.96419 11.5019 4.96419C14.9697 4.96419 17.7908 7.65165 17.7908 10.9551C17.7908 14.2585 14.9697 16.946 11.5019 16.946ZM17.9412 6.37704C16.9164 6.37704 16.0829 5.58302 16.0829 4.6068C16.0829 3.63058 16.9164 2.8364 17.9412 2.8364C18.966 2.8364 19.7997 3.63058 19.7997 4.6068C19.7997 5.58302 18.966 6.37704 17.9412 6.37704Z",
    fill: "#9B9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.502 6.24805C8.77796 6.24805 6.56152 8.3593 6.56152 10.9545C6.56152 13.5495 8.77796 15.6609 11.502 15.6609C14.2263 15.6609 16.4426 13.5495 16.4426 10.9545C16.4426 8.3593 14.2263 6.24805 11.502 6.24805Z",
    fill: "#9B9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9413 4.12109C17.6602 4.12109 17.4314 4.33907 17.4314 4.60686C17.4314 4.87466 17.6602 5.09264 17.9413 5.09264C18.2226 5.09264 18.4514 4.87482 18.4514 4.60686C18.4514 4.33891 18.2226 4.12109 17.9413 4.12109Z",
    fill: "#9B9999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21.9102,
    fill: "white",
    transform: "translate(0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.071c0c41.svg";
export { ForwardRef as ReactComponent };